import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import * as moment from 'moment';
import { BaseComponent } from 'src/app/_base/base.component';
import { ClassSection } from 'src/app/_models/academic/attendance/ClassSection';
import { StudyTableService } from 'src/app/_services';
import { CategoryDays } from 'src/app/_models';
@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DatepickerComponent extends BaseComponent implements OnInit, OnChanges {
  @Input()
  isWeekable: boolean = false;
  @Input()
  isMaxDateToday: boolean = true;
  @Input()
  filter: ClassSection = {
    classId: null,
    sectionId: null
  };
  @Output() dateEmitter: EventEmitter<string> = new EventEmitter<string>();
  date: string = moment()
    .locale('en')
    .format('YYYY-MM-DD');
  currentday: Date;
  CurrentWeek: any[];
  week: string[];
  schoolDays: number[] = [];
  maxDate: Date = moment().toDate();
  sectionDaysFilter = (d: Date): boolean => {
    return false;
    // tslint:disable-next-line:semicolon
  };
  constructor(private studyTableService: StudyTableService) {
    super();
    this.weekNameCreator();
    this.weekCreator();
  }

  ngOnInit() {
    this.dateInit();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filter) this.dateInit();
  }
  dateInit(): void {
    if (this.filter && this.filter.classId && this.filter.sectionId) this.getSchoolDaysByClassSection();
    else {
      this.schoolDays = [0, 1, 2, 3, 4, 5, 6];
      this.activeDaysInit();
    }
  }
  getSchoolDaysByClassSection(): void {
    this.schoolDays = [];
    if (BaseComponent.spinner) BaseComponent.spinner.isActive = true;
    this.studyTableService.GetDaysByClassSection(this.filter.classId, this.filter.sectionId).subscribe(
      (data: CategoryDays) => {
        if (data) {
          data.days.map(items => {
            this.schoolDays.push(items.id - 1);
          });
        }
        this.activeDaysInit();
        this.selectedDayInit();
        BaseComponent.spinner.isActive = false;
      },
      () => {
        this.showWarning('AttendanceModule.ThisSectionNotLinkedWithAnyTimeTable');
        this.activeDaysInit();
        BaseComponent.spinner.isActive = false;
      }
    );
  }
  activeDaysInit(): void {
    this.sectionDaysFilter = (d: Date): boolean => {
      const day = d.getDay();
      if (this.isMaxDateToday)
        return (
          this.schoolDays.find(item => item === day) === day &&
          moment(
            moment(d)
              .locale('en')
              .format('YYYY-MM-DD')
          ).isSameOrBefore(
            moment()
              .locale('en')
              .format('YYYY-MM-DD')
          )
        );
      else return this.schoolDays.find(item => item === day) === day;
    };
  }
  selectedDayInit(isIncrement: boolean = false): void {
    const currentDayIndex = moment(this.date).day();
    if (this.schoolDays.findIndex(item => item === currentDayIndex) === -1 && this.schoolDays.length > 0) {
      for (let index = 0; index < 7; index++) {
        this.date = moment(this.date)
          .locale('en')
          .add(isIncrement ? 1 : -1, 'd')
          .format('YYYY-MM-DD');
        if (this.schoolDays.findIndex(item => item === moment(this.date).day()) !== -1) {
          break;
        }
      }
    }
  }
  weekNameCreator() {
    this.week = ['WeekDays.Su', 'WeekDays.Mo', 'WeekDays.Tu', 'WeekDays.We', 'WeekDays.Th', 'WeekDays.Fr', 'WeekDays.Sa'];
  }
  weekCreator() {
    this.CurrentWeek = [];
    const first = this.getFirstDayOfweek(this.date);

    this.CurrentWeek.push(first);
    for (let i = 0; i < 6; i++) {
      this.CurrentWeek.push(this.getNextdate(this.CurrentWeek[i]));
    }
  }

  OnDayClick(d) {
    this.date = moment(d)
      .locale('en')
      .format('YYYY-MM-DD');
    this.dateEmitter.emit(this.schoolDays.length > 0 ? this.date : null);
  }

  calenderChanged(): void {
    this.dateEmitter.emit(
      this.schoolDays.length > 0
        ? moment(this.date)
            .locale('en')
            .format('YYYY-MM-DD')
        : null
    );
    this.weekCreator();
  }

  dateChanger(index: number): void {
    if (index === 0) {
      this.date = moment(this.date)
        .add(-1, 'd')
        .locale('en')
        .format('YYYY-MM-DD');
      this.selectedDayInit();
      this.dateEmitter.emit(this.schoolDays.length > 0 ? this.date : null);
      this.weekCreator();
    } else if (!this.isDisabledIncrement()) {
      this.date = moment(this.date)
        .add(1, 'd')
        .locale('en')
        .format('YYYY-MM-DD');
      this.selectedDayInit(true);
      this.dateEmitter.emit(this.schoolDays.length > 0 ? this.date : null);
      this.weekCreator();
    }
  }
  private getFirstDayOfweek(date: string) {
    const temp = moment(date).toDate();
    return moment(new Date(temp.setDate(temp.getDate() - temp.getDay())));
  }

  private getNextdate(d) {
    return moment(d).add(1, 'd');
  }

  isActiveDate(d): boolean {
    return moment(this.date).isSame(d);
  }
  isDisabledDate(day: string): boolean {
    return (
      this.schoolDays.findIndex(item => item === moment(day).day()) === -1 || (moment(day).isAfter(this.maxDate) && this.isMaxDateToday)
    );
  }
  isDisabledIncrement(): boolean {
    return (
      moment(this.date)
        .locale('en')
        .add(1, 'd')
        .isAfter(this.maxDate) && this.isMaxDateToday
    );
  }
  getCorrectDay(d) {
    return moment(d)
      .toDate()
      .getDay();
  }
}
